import { render, staticRenderFns } from "./TableCollections.vue?vue&type=template&id=a97ec086&scoped=true"
import script from "./TableCollections.vue?vue&type=script&lang=js"
export * from "./TableCollections.vue?vue&type=script&lang=js"
import style0 from "./TableCollections.vue?vue&type=style&index=0&id=a97ec086&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a97ec086",
  null
  
)

export default component.exports